// @flow
import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";

import { buttonStyles } from "../../global/components/StyledButtons";
import { ColorSchema } from "../types/scss";

type CompleteMessagePropsType = {
  content: string,
  title: string,
  onClick?: Function,
  buttonText?: string,
  extraBlock?: React$Element<*>
};

class CompleteMessage extends Component<*, CompleteMessagePropsType> {
  constructor(props: CompleteMessagePropsType) {
    super(props);
  }

  render(): React$Element<*> {
    const content = this.props.content.split("<br>").map((item: string, i: number) => <p key={i}>{item}</p>);
    const classes = this.props.classes;
    return (
      <div className="flag-wrapper" style={{ backgroundColor: ColorSchema("third") }}>
        <div className="flag-text">
          <span className="flag-title">{this.props.title}</span><br />
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2" className="check-mark">
            <circle className="path circle" fill="none" stroke={ColorSchema("primary")} strokeWidth="9" strokeMiterlimit="10" cx="65.1" cy="65.1" r="60.1" />
            <polyline className="path check" fill="none" stroke={ColorSchema("primary")} strokeWidth="12" strokeLinecap="round" strokeMiterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
          </svg>
          <div className="flag-content">{content}</div>
          {this.props.onClick !== null &&
            <Button color="primary" variant="raised" type='button' className={classes.primaryBtn + " top-margin-15"} style={{ width: "auto" }} onClick={this.props.onClick}>{this.props.buttonText}</Button>
          }
          {this.props.extraBlock}
        </div>
      </div>
    );
  }
};

export default withStyles(buttonStyles)(CompleteMessage);



// WEBPACK FOOTER //
// ./src/global/components/CompleteMessage.js